import { Variants } from '../Input/Input.types.js';

///////////////////////////////////////////////////////////////////////////////
var EValidationFields;
(function (EValidationFields) {
    EValidationFields["CC_NUMBER"] = "ccnumber";
    EValidationFields["CVV"] = "cvv";
    EValidationFields["CC_EXPIRY"] = "ccexp";
})(EValidationFields || (EValidationFields = {}));
var defaultProps = {
    ccNumberLabel: 'Card Number *',
    expirationDateLabel: 'Expiration Date *',
    cvvLabel: 'CVV *',
    postalCodeLabel: 'Postal Code *',
    variant: Variants.DEFAULT,
    borderColor: '#C0C3C3',
    v2: false,
    isPostalCodeInputVisible: true,
};

export { EValidationFields, defaultProps };
